import cx from "classnames";
import React from "react";
import { formatSecondsToMMSS } from "./helper";
import style from "./StartVoteWindow.module.css";

export type StartVoteWindowVote = {
    UID: string;
    duration: number;
    creatorName: string;
};

type StartVoteWindowProps = {
    onClose: () => void;
    onAccept: () => void;
    vote: StartVoteWindowVote;
};

export function StartVoteWindow({ vote, onClose, onAccept }: StartVoteWindowProps) {
    const handleAccept = () => {
        onAccept();
        onClose();
    };
    return (
        <div className={style.startVoteWindowWrapper}>
            <div className={style.startVoteWindow}>
                <div className={style.header}>
                    <h2 className={style.title}>Началось голосование</h2>
                    <p className={style.titleDescription}>Проводит: {vote.creatorName}</p>
                    <button
                        onMouseUp={onClose}
                        className={cx(style.close, "button", "button--close")}
                        type="button"
                        aria-label="Закрыть"
                    />
                </div>
                <div className={style.details}>
                    <p className={style.detailsText}>Время на голосование:</p>
                    <p className={style.detailsTimer}>{formatSecondsToMMSS(vote.duration)}</p>
                </div>
                <div className={style.buttons}>
                    <button
                        onMouseUp={handleAccept}
                        type="button"
                        className={cx("button", "button--primary")}
                    >
                        Присоединиться
                    </button>
                    <button onMouseUp={onClose} type="button" className="button">
                        Пропустить
                    </button>
                </div>
            </div>
        </div>
    );
}
